<template>
  <div class="nav-bar no-print">
    
    <nav class="navbar is-primary is-fixed-top">
      <div class="navbar-brand">
        <div class="navbar-burger burger" data-target="navbarExampleTransparentExample" @click="toggleMenu" :class="{'is-active': navIsActive}">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div id="navbarExampleTransparentExample" class="navbar-menu" :class="{'is-active': navIsActive}">
        <div class="navbar-start">
          <div class="navbar-item">Lampe & Malphrus</div>
          <router-link v-if="isLoggedIn && viewingDashboard" style="color: red; background-color: white" class="navbar-item" v-on:click.native="closeMenu" :to="{ name: 'DashboardPage'}">Dashboard</router-link>
          <router-link v-else-if="isLoggedIn" class="navbar-item" v-on:click.native="closeMenu" :to="{ name: 'DashboardPage'}">Dashboard</router-link>
          <router-link v-if="isLoggedIn && viewingNewPO" style="color: red; background-color: white" class="navbar-item" v-on:click.native="closeMenu" :to="{ name: 'PurchaseOrderNewPage'}">New PO</router-link>
          <router-link v-else-if="isLoggedIn"  class="navbar-item" v-on:click.native="closeMenu" :to="{ name: 'PurchaseOrderNewPage'}">New PO</router-link>
          <!-- <router-link v-if="isLoggedIn && viewingSearch" style="color: red; background-color: white" class="navbar-item" v-on:click.native="closeMenu" :to="{ name: 'SearchPage'}">Search</router-link>
          <router-link v-else-if="isLoggedIn"  class="navbar-item" v-on:click.native="closeMenu" :to="{ name: 'SearchPage'}">Search</router-link> -->
        </div>
        <div class="navbar-end">
          <template v-if="isLoggedIn">
            <span class="navbar-item">{{ userInfo.employeeName }}</span>
            <router-link class="navbar-item" v-on:click.native="closeMenu" :to="{ name: 'Logout' }">Log out</router-link>
          </template>
          <template v-else>
            <router-link class="navbar-item" v-on:click.native="closeMenu" :to="{ name: 'LoginPage'}">Login</router-link>
          </template>     
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mapGetters } from 'vuex'

export default {
  name: 'NavBar',
  data () {
    return {
      navIsActive: false
    }
  },
  
  computed:{
    ...mapGetters([
      'isLoggedIn', 'isTokenExpired', 'employeeName'
    ]),
    ...mapState([
      'userInfo',
      'currentPage'
    ]),
    viewingDashboard(){
      if(this.currentPage == "dashboard") return true;
      return false
    },
    viewingNewPO(){
      if(this.currentPage == "new") return true;
      return false
    },
    viewingSearch(){
      if(this.currentPage == "search") return true;
      return false
    }
  },
  methods: {
    toggleMenu: function () {
      this.navIsActive = !this.navIsActive
    },
    closeMenu: function () {
      this.navIsActive = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
span.icon{
  margin-right: 5px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue